// 引入安装的signalr包<br>import * as signalR from '@aspnet/signalr'
// 服务器地址
import * as signalR from '@aspnet/signalr'
var url=process.env.VUE_APP_SignalR_API
const signal = new signalR.HubConnectionBuilder()
  .withUrl(url+'/IMHub', {
    skipNegotiation: true,
    transport: signalR.HttpTransportType.WebSockets
  })
  .configureLogging(signalR.LogLevel.Information)
  .build()

// 服务端掉线
signal.onclose(() => {
  console.log('服务器掉线')
  Start()
})

//  自动重连
export function Start() {
  try {
    signal.start().then(() => {
      console.log('重连成功')
    }).catch(() => {
      setTimeout(() => Start(), 5000)
    })
  } catch (err) {
    console.log('重连失败', err)
    setTimeout(() => Start(), 5000)
  }
}

// // 登录平板
// export function LoginPad() {
//   try {
//     var userId = parseInt(store.getters.user.id)
//     signal.invoke('login', userId)
//   } catch (e) {
//     console.log('LoginPad')
//   }
// }

// // 登出平板
// export function LogoutPad() {
//   try {
//     console.log(signal)
//     signal.stop()
//   } catch (e) {
//     console.log('LogoutPad')
//   }
// }

// 发送指令
export function SendMsg(type:any, actionObjectId:any, remark = '') {
  try {
    console.log(signal)
    // var userId = parseInt(store.getters.user.id)
    // signal.invoke('oper', { 1, type, actionObjectId, remark })
  } catch (e) {
    console.log('SendMsg')
  }
}

// 获取signalr实例
export function GetSignalr() {
  return signal
}
